var map = {
	"./gestaoDocumentos.js": "D64x",
	"./index.js": "Mwck"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cSv0";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/gestaoDocumentos nonrecursive \.js$
// module id = cSv0
// module chunks = 12